import { render } from "./CreditsScreen.vue?vue&type=template&id=67defeb2&scoped=true&bindings={}"
import script from "./CreditsScreen.vue?vue&type=script&lang=ts"
export * from "./CreditsScreen.vue?vue&type=script&lang=ts"

import "./CreditsScreen.vue?vue&type=style&index=0&id=67defeb2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-67defeb2"

export default script